
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"100%","height":"100%","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M18 3c-.78 0-1.53.31-2.082.862L5.21 14.571a1 1 0 0 0-.263.464l-.917 3.667a1 1 0 0 0 1.213 1.213l3.666-.917a1 1 0 0 0 .465-.263L20.082 8.027A2.945 2.945 0 0 0 18 3Zm-.668 2.277a.945.945 0 0 1 1.336 1.335L18 7.28l-1.336-1.335.668-.668ZM15.25 7.359l1.336 1.336-8.43 8.43-1.782.445.446-1.78 8.43-8.431Z","fill":"currentColor"}})])
          )
        }
      }
    